import axios from "axios";

import {
  AUTH_FETCH_CURRENT_USER,
  BILLING_CREATE_SUBSCRIPTION,
  BILLING_FETCH_BILLING_DATA,
  BILLING_UPDATE_CARD,
  BILLING_CANCEL_SUBSCRIPTION,
  BILLING_ACTION_REQUIRED,
  ACTION_STARTED,
  ACTION_ENDED,
  ACTION_SUCCESS,
  ACTION_RESET,
  ACTION_ERROR,
} from "./types";

import { catchBlockError } from "./functions";

// --- APUFUNKTIOT ---
const getAuthHeader = () => ({
  headers: { authorization: localStorage.getItem("token") },
});

// --- TILAUKSEN VIIMEISTELY SCA:N JÄLKEEN ---
export const finalizeSubscriptionAfterSCA = (subscriptionId, onSuccess) => async (dispatch) => {
  dispatch({ type: ACTION_STARTED, payload: BILLING_CREATE_SUBSCRIPTION });
  try {
    const res = await axios.post(
      "/api/billing/stripe/finalize_subscription_after_sca",
      { subscriptionId },
      getAuthHeader()
    );

    dispatch({ type: AUTH_FETCH_CURRENT_USER, payload: res.data.user });
    dispatch({ type: ACTION_SUCCESS, payload: "createSubscriptionSuccess" });
    
    if (onSuccess) onSuccess();
    return res.data;
  } catch (error) {
    catchBlockError(error, dispatch);
  } finally {
    dispatch({ type: ACTION_ENDED });
    setTimeout(() => dispatch({ type: ACTION_RESET }), 1000);
  }
};

// --- LASKUTUSTIETOJEN HAKU ---
export const fetchBillingData = () => async (dispatch) => {
  dispatch({ type: ACTION_STARTED, payload: BILLING_FETCH_BILLING_DATA });
  try {
    const res = await axios.get('/api/billing/stripe/subscription_data', getAuthHeader());
    dispatch({ type: BILLING_FETCH_BILLING_DATA, payload: res.data });
  } catch (error) {
    catchBlockError(error, dispatch);
  } finally {
    dispatch({ type: ACTION_ENDED });
    dispatch({ type: ACTION_RESET });
  }
};

// --- TILAUKSEN PERUUTUS ---
export const cancelSubscription = () => async (dispatch) => {
  dispatch({ type: ACTION_STARTED, payload: BILLING_CANCEL_SUBSCRIPTION });
  try {
    const res = await axios.get("/api/billing/stripe/cancel_subscription", getAuthHeader());
    dispatch({ type: AUTH_FETCH_CURRENT_USER, payload: res.data.user });
    dispatch({ type: ACTION_SUCCESS, payload: "cancelSubscriptionSuccess" });
  } catch (error) {
    catchBlockError(error, dispatch);
  } finally {
    dispatch({ type: ACTION_ENDED });
    setTimeout(() => dispatch({ type: ACTION_RESET }), 3000);
  }
};

// --- MAKSUTAVAN VAATIMUKSEN ASETTAMINEN ---
export const setPaymentMethodRequired = () => async (dispatch) => {
  dispatch({ type: ACTION_STARTED, payload: BILLING_ACTION_REQUIRED });
  try {
    const res = await axios.get("/api/billing/stripe/set_payment_method_required", getAuthHeader());
    dispatch({ type: AUTH_FETCH_CURRENT_USER, payload: res.data.user });
  } catch (error) {
    catchBlockError(error, dispatch);
  } finally {
    dispatch({ type: ACTION_ENDED });
    setTimeout(() => dispatch({ type: ACTION_RESET }), 1000);
  }
};

// --- SETUP INTENTIN HALLINTA (Kortin päivitys) ---
export const createSetupIntent = () => async (dispatch) => {
  dispatch({ type: ACTION_STARTED, payload: BILLING_UPDATE_CARD });

  try {
    const { data } = await axios.get("/api/billing/stripe/create_setup_intent", getAuthHeader());

    // Päivitetään käyttäjä ja palautetaan secret
    dispatch({ type: AUTH_FETCH_CURRENT_USER, payload: data.user });
    return data.client_secret;

  } catch (error) {
    // Käytetään yhteistä virhekäsittelijää (joka nyt tunnistaa myös STRIPE-koodit)
    catchBlockError(error, dispatch);
  } finally {
    dispatch({ type: ACTION_ENDED });
    
    // Nollataan tila (esim. latausikonit ja virheviestit) hetken kuluttua
    setTimeout(() => {
      dispatch({ type: ACTION_RESET });
    }, 2000);
  }
};
//
export const finalizePaymentMethod = (intent, onSuccess) => async (dispatch) => {
  // 1. Aloitetaan lataustila
  dispatch({ type: ACTION_STARTED, payload: BILLING_UPDATE_CARD });

  // 2. Pura ID huolellisesti
  const intentId = (intent && typeof intent === 'object') ? intent.id : intent;

  console.log("--- FRONTEND DEBUG: finalizePaymentMethod ---");
  console.log("Intent ID being sent:", intentId);

  if (!intentId) {
    console.error("Critical Error: No Intent ID available to finalize.");
    dispatch({ type: ACTION_ENDED });
    return;
  }

  try {
    // 3. Kutsutaan backendia
    const res = await axios.post(
      "/api/billing/stripe/finalize_payment_method",
      { intentId }, // Lähetetään selkeänä objektina
      getAuthHeader()
    );

    // 4. Tarkistetaan, että saimme varmasti käyttäjädatan takaisin
    if (res.data && res.data.user) {
      console.log("Backend returned user successfully:", res.data.user);

      // Päivitetään käyttäjä globaaliin tilaan (Tämä korjaa Headerin)
      dispatch({ type: AUTH_FETCH_CURRENT_USER, payload: res.data.user });
      
      // Ilmoitetaan onnistumisesta
      dispatch({ type: ACTION_SUCCESS, payload: "updateCardSuccess" });

      // Suoritetaan mahdollinen jatkotoimenpide (esim. ohjaus kiitossivulle)
      if (onSuccess) onSuccess();
    } else {
      // Jos backend palauttaa 200 OK mutta data on outoa
      throw new Error("Backend responded but user data was missing.");
    }

  } catch (error) {
    console.error("Error in finalizePaymentMethod action:", error);
    
    // Käytetään sovelluksen omaa virhekäsittelijää
    if (typeof catchBlockError === 'function') {
      catchBlockError(error, dispatch);
    } else {
      dispatch({ type: ACTION_ERROR, payload: error.message });
    }
  } finally {
    // 5. Siivotaan lataustilat joka tapauksessa
    dispatch({ type: ACTION_ENDED });
    
    // Resetoidaan action-tila pienen viiveen jälkeen (esim. poistetaan success-viestit)
    setTimeout(() => {
      dispatch({ type: ACTION_RESET });
    }, 2000);
  }
};

export const createCustomerAndSubscription = (paymentMethod, stripe) => async (dispatch) => {
  dispatch({ type: ACTION_STARTED, payload: BILLING_CREATE_SUBSCRIPTION });
  
  try {
    const res = await axios.post('/api/billing/stripe/first_time_subscription', { paymentMethod }, getAuthHeader());
    
    if (!res.data) throw new Error("No response data received");

    const { subscription, user } = res.data;
    const paymentIntent = subscription?.latest_invoice?.payment_intent;

    if (paymentIntent?.status === 'requires_action') {
      const { error: confirmError, paymentIntent: confirmedIntent } = await stripe.confirmCardPayment(paymentIntent.client_secret);
      
      if (confirmError) {
        // TÄRKEÄÄ: Heitetään Stripen virhe sellaisenaan, jotta catch nappaa sen
        throw confirmError; 
      }

      if (confirmedIntent.status === 'succeeded') {
        dispatch({ type: ACTION_SUCCESS, payload: 'createSubscriptionSuccess' });
        dispatch({ type: AUTH_FETCH_CURRENT_USER, payload: user });
        return subscription;
      }
    } else {
      dispatch({ type: ACTION_SUCCESS, payload: 'createSubscriptionSuccess' });
      dispatch({ type: AUTH_FETCH_CURRENT_USER, payload: user });
      return subscription;
    }
  } catch (error) {
    console.error("Billing Flow Error:", error);

    // Tarkistetaan löytyykö backendin lähettämä tarkka virhekoodi
    // Axios pakkaa backend-vastauksen error.response.data sisään
    const stripeErrorCode = error.response?.data?.code || error.code;
    const errorMessage = error.response?.data?.message || error.message;

    if (stripeErrorCode === 'expired_card') {
      // Voit lähettää dispatchilla spesifin virheen reduserille
      dispatch({ 
        type: ACTION_ERROR, 
        payload: 'Korttisi on vanhentunut. Päivitä korttiedot.' 
      });
    } else {
      // Jos ei ole spesifiä käsittelyä, käytä olemassa olevaa apufunktiota
      catchBlockError(error, dispatch);
    }
  } finally {
    dispatch({ type: ACTION_ENDED });
    setTimeout(() => dispatch({ type: ACTION_RESET }), 3000);
  }
};

// --- TILAUKSEN LUONTI (OLEMASSA OLEVA ASIAKAS) ---
export const createSubscriptionExistingCustomer = (paymentMethod, stripe) => async (dispatch) => {
  dispatch({ type: ACTION_STARTED, payload: BILLING_CREATE_SUBSCRIPTION });
  try {
    const res = await axios.post('/api/billing/stripe/create_subscription_existing_customer', { paymentMethod }, getAuthHeader());
    const { subscription, user } = res.data;
    const paymentIntent = subscription.latest_invoice.payment_intent;

    if (paymentIntent?.status === 'requires_action') {
      const { error: confirmError, paymentIntent: confirmedIntent } = await stripe.confirmCardPayment(paymentIntent.client_secret);
      if (confirmError) throw new Error(confirmError.message);

      if (confirmedIntent.status === 'succeeded') {
        dispatch({ type: ACTION_SUCCESS, payload: 'createSubscriptionSuccess' });
        dispatch({ type: AUTH_FETCH_CURRENT_USER, payload: user });
        return subscription;
      }
    } else {
      dispatch({ type: ACTION_SUCCESS, payload: 'createSubscriptionSuccess' });
      dispatch({ type: AUTH_FETCH_CURRENT_USER, payload: user });
      return subscription;
    }
 } catch (error) {
    console.error("Billing Flow Error:", error);

    // Tarkistetaan löytyykö backendin lähettämä tarkka virhekoodi
    // Axios pakkaa backend-vastauksen error.response.data sisään
    const stripeErrorCode = error.response?.data?.code || error.code;
    const errorMessage = error.response?.data?.message || error.message;

    if (stripeErrorCode === 'expired_card') {
      // Voit lähettää dispatchilla spesifin virheen reduserille
      dispatch({ 
        type: ACTION_ERROR, 
        payload: 'Korttisi on vanhentunut. Päivitä korttiedot.' 
      });
    } else {
      // Jos ei ole spesifiä käsittelyä, käytä olemassa olevaa apufunktiota
      catchBlockError(error, dispatch);
    }
  } finally {
    dispatch({ type: ACTION_ENDED });
    setTimeout(() => dispatch({ type: ACTION_RESET }), 3000);
  }
};

// --- EXPORTIT ---
const billingActions = {
  finalizeSubscriptionAfterSCA,
  fetchBillingData,
  cancelSubscription,
  setPaymentMethodRequired,
  createSetupIntent,
  finalizePaymentMethod,
  createCustomerAndSubscription,
  createSubscriptionExistingCustomer,
};

export default billingActions;